export class LoginModel {
  username: string;
  password: string;
  rememberMe: boolean;
}

export class LoginResponse {
	access_token: string;
	userId: string;
	userName: string;
	expires_in:string;
	role:string;
	issued;
	'.expires';
}

export class CurrentUser {
	username;
	userRole;
	token;
	remember;
	expires;
	userId;
	constructor(response: LoginResponse) {
		this.userId = response.userId;
		this.username = response.userName;
		this.token = response.access_token;
		this.userRole = response.role;
		this.expires = response[".expires"];
	}
	
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/loginModel.ts